<template>
  <v-text-field
    v-model="searchKey"
    ref="search"
    outline
    hide-details
    placeholder="Search sessions..."
    prepend-inner-icon="search"
    height="40px"
    @change="filterData()"
  ></v-text-field>
</template>

<script>
export default {
  name: "searchKey",
  data() {
    return {
      searchKey: "",
    };
  },
  mounted() {},
  methods: {
    filterData() {
      this.$emit("searchFilter", this.searchKey.trim());
    },
  },
};
</script>

<style scoped></style>
